export const heroSlides = [
  {
    id: 1,
    title: "流浪地球3",
    subtitle: "中国科幻史诗巨制 · 2026年最受期待大片",
    category: "科幻 / 冒险",
    rating: 9.2,
    imageUrl: "https://readdy.ai/api/search-image?query=Epic%20Chinese%20sci-fi%20movie%20poster%20with%20astronaut%20and%20massive%20space%20station%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20warm%20orange%20and%20gold%20tones%2C%20movie%20poster%20style%2C%20grand%20scale%2C%20atmospheric&width=1800&height=800&seq=hero-slide-1&orientation=landscape",
    link: "/detail/1",
  },
  {
    id: 2,
    title: "封神第二部",
    subtitle: "神话史诗再续传奇 · 视觉盛宴震撼来袭",
    category: "奇幻 / 动作",
    rating: 8.9,
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20mythological%20fantasy%20film%20poster%20with%20ancient%20warriors%20and%20mythical%20creatures%2C%20epic%20battle%20scene%2C%20golden%20and%20crimson%20tones%2C%20traditional%20Chinese%20aesthetic%2C%20cinematic%20lighting%2C%20grand%20scale%20composition&width=1800&height=800&seq=hero-slide-2&orientation=landscape",
    link: "/detail/2",
  },
  {
    id: 3,
    title: "哪吒之魔童闹海",
    subtitle: "国产动画新标杆 · 票房口碑双丰收",
    category: "动画 / 奇幻",
    rating: 9.5,
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20animated%20film%20poster%20with%20mythological%20character%20in%20dynamic%20pose%2C%20vibrant%20red%20and%20gold%20color%20scheme%2C%20epic%20cloud%20and%20fire%20effects%2C%20Chinese%20ink%20painting%20style%2C%20cinematic%20lighting%2C%20dramatic%20composition&width=1800&height=800&seq=hero-slide-3&orientation=landscape",
    link: "/detail/3",
  },
];

export const categories = [
  { id: "movie", name: "电影", icon: "ri-movie-2-line", count: 12860, slug: "movie" },
  { id: "tv", name: "电视剧", icon: "ri-tv-2-line", count: 8650, slug: "tv" },
  { id: "anime", name: "动漫", icon: "ri-ghost-smile-line", count: 5420, slug: "anime" },
  { id: "variety", name: "综艺", icon: "ri-live-line", count: 3890, slug: "variety" },
  { id: "documentary", name: "纪录片", icon: "ri-film-line", count: 2150, slug: "documentary" },
];

export const hotMovies = [
  {
    id: 1,
    title: "流浪地球3",
    year: 2026,
    category: "科幻 / 冒险",
    rating: 9.2,
    region: "中国大陆",
    imageUrl: "https://readdy.ai/api/search-image?query=Epic%20Chinese%20science%20fiction%20movie%20poster%20with%20futuristic%20space%20station%20and%20earth%2C%20warm%20orange%20lighting%2C%20cinematic%20style%2C%20dramatic%20atmosphere%2C%20movie%20poster%20design%2C%20clean%20background&width=600&height=800&seq=movie-1&orientation=portrait",
    tags: ["热门", "新片"],
  },
  {
    id: 2,
    title: "封神第二部",
    year: 2026,
    category: "奇幻 / 动作",
    rating: 8.9,
    region: "中国大陆",
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20mythological%20fantasy%20epic%20movie%20poster%20with%20ancient%20warriors%2C%20golden%20and%20red%20tones%2C%20cinematic%20style%2C%20dramatic%20lighting%2C%20movie%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=movie-2&orientation=portrait",
    tags: ["热门"],
  },
  {
    id: 3,
    title: "哪吒之魔童闹海",
    year: 2025,
    category: "动画 / 奇幻",
    rating: 9.5,
    region: "中国大陆",
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20animated%20film%20poster%20with%20mythological%20hero%20character%2C%20vibrant%20red%20tones%2C%20dynamic%20pose%2C%20cinematic%20lighting%2C%20movie%20poster%20design%2C%20clean%20background&width=600&height=800&seq=movie-3&orientation=portrait",
    tags: ["高分"],
  },
  {
    id: 4,
    title: "奥本海默",
    year: 2023,
    category: "剧情 / 传记",
    rating: 8.8,
    region: "美国",
    imageUrl: "https://readdy.ai/api/search-image?query=Dramatic%20biographical%20film%20poster%20with%20intense%20portrait%20and%20atomic%20motif%2C%20dark%20and%20warm%20tones%2C%20cinematic%20lighting%2C%20movie%20poster%20design%2C%20clean%20composition%2C%20atmospheric&width=600&height=800&seq=movie-4&orientation=portrait",
    tags: ["高分", "经典"],
  },
  {
    id: 5,
    title: "孤注一掷",
    year: 2025,
    category: "犯罪 / 剧情",
    rating: 8.6,
    region: "中国大陆",
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20film%20poster%20with%20tense%20atmosphere%2C%20urban%20night%20setting%2C%20red%20and%20dark%20tones%2C%20cinematic%20lighting%2C%20movie%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=movie-5&orientation=portrait",
    tags: ["热门"],
  },
  {
    id: 6,
    title: "碟中谍8",
    year: 2025,
    category: "动作 / 冒险",
    rating: 8.4,
    region: "美国",
    imageUrl: "https://readdy.ai/api/search-image?query=Hollywood%20action%20spy%20film%20poster%20with%20dynamic%20stunt%20scene%2C%20urban%20setting%2C%20warm%20golden%20tones%2C%20cinematic%20lighting%2C%20movie%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=movie-6&orientation=portrait",
    tags: ["新片"],
  },
  {
    id: 7,
    title: "热辣滚烫",
    year: 2025,
    category: "喜剧 / 剧情",
    rating: 8.2,
    region: "中国大陆",
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20comedy%20drama%20film%20poster%20with%20warm%20and%20uplifting%20atmosphere%2C%20bright%20lighting%2C%20cinematic%20style%2C%20movie%20poster%20design%2C%20clean%20composition%2C%20joyful%20tone&width=600&height=800&seq=movie-7&orientation=portrait",
    tags: ["热门"],
  },
  {
    id: 8,
    title: "沙丘2",
    year: 2025,
    category: "科幻 / 冒险",
    rating: 8.7,
    region: "美国",
    imageUrl: "https://readdy.ai/api/search-image?query=Epic%20science%20fiction%20film%20poster%20with%20desert%20landscape%20and%20massive%20sandworms%2C%20warm%20golden%20and%20orange%20tones%2C%20cinematic%20lighting%2C%20movie%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=movie-8&orientation=portrait",
    tags: ["高分"],
  },
];

export const latestMovies = [
  {
    id: 9,
    title: "庆余年第二季",
    year: 2025,
    category: "古装 / 权谋",
    rating: 8.8,
    region: "中国大陆",
    type: "电视剧",
    episodes: "36集全",
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20historical%20costume%20drama%20poster%20with%20ancient%20palace%20setting%2C%20elegant%20characters%2C%20warm%20golden%20tones%2C%20cinematic%20lighting%2C%20TV%20series%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=movie-9&orientation=portrait",
  },
  {
    id: 10,
    title: "与凤行",
    year: 2025,
    category: "仙侠 / 爱情",
    rating: 8.4,
    region: "中国大陆",
    type: "电视剧",
    episodes: "39集全",
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20fantasy%20romance%20drama%20poster%20with%20ethereal%20characters%20in%20flowing%20robes%2C%20soft%20pink%20and%20gold%20tones%2C%20cinematic%20lighting%2C%20TV%20series%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=movie-10&orientation=portrait",
  },
  {
    id: 11,
    title: "熊出没·逆转时空",
    year: 2025,
    category: "动画 / 喜剧",
    rating: 8.1,
    region: "中国大陆",
    type: "电影",
    episodes: "",
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20animated%20family%20film%20poster%20with%20cute%20bear%20characters%20in%20colorful%20adventure%20scene%2C%20bright%20and%20warm%20tones%2C%20cinematic%20lighting%2C%20movie%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=movie-11&orientation=portrait",
  },
  {
    id: 12,
    title: "狂飙",
    year: 2024,
    category: "犯罪 / 剧情",
    rating: 9.1,
    region: "中国大陆",
    type: "电视剧",
    episodes: "39集全",
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20TV%20series%20poster%20with%20intense%20character%20portraits%2C%20dark%20urban%20setting%2C%20dramatic%20warm%20lighting%2C%20TV%20series%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=movie-12&orientation=portrait",
  },
  {
    id: 13,
    title: "哥斯拉大战金刚2",
    year: 2025,
    category: "动作 / 科幻",
    rating: 8.0,
    region: "美国",
    type: "电影",
    episodes: "",
    imageUrl: "https://readdy.ai/api/search-image?query=Hollywood%20monster%20action%20film%20poster%20with%20giant%20creatures%20battling%20in%20city%2C%20epic%20scale%2C%20warm%20orange%20and%20red%20tones%2C%20cinematic%20lighting%2C%20movie%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=movie-13&orientation=portrait",
  },
  {
    id: 14,
    title: "去有风的地方",
    year: 2024,
    category: "治愈 / 爱情",
    rating: 8.5,
    region: "中国大陆",
    type: "电视剧",
    episodes: "40集全",
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20healing%20romance%20drama%20poster%20with%20beautiful%20rural%20landscape%2C%20warm%20sunlight%2C%20gentle%20and%20peaceful%20atmosphere%2C%20cinematic%20lighting%2C%20TV%20series%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=movie-14&orientation=portrait",
  },
  {
    id: 15,
    title: "间谍过家家",
    year: 2025,
    category: "动画 / 喜剧",
    rating: 8.9,
    region: "日本",
    type: "动漫",
    episodes: "更新至25集",
    imageUrl: "https://readdy.ai/api/search-image?query=Japanese%20anime%20spy%20family%20comedy%20poster%20with%20stylish%20characters%20in%20elegant%20setting%2C%20warm%20and%20bright%20color%20palette%2C%20anime%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=movie-15&orientation=portrait",
  },
  {
    id: 16,
    title: "唐探1900",
    year: 2025,
    category: "悬疑 / 喜剧",
    rating: 8.3,
    region: "中国大陆",
    type: "电影",
    episodes: "",
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20mystery%20comedy%20film%20poster%20with%20detective%20theme%20and%20historical%20setting%2C%20warm%20vintage%20tones%2C%20cinematic%20lighting%2C%20movie%20poster%20design%2C%20clean%20composition&width=600&height=800&seq=movie-16&orientation=portrait",
  },
];

export const faqData = [
  {
    question: "被窝网电影是否需要注册才能观看？",
    answer: "不需要！被窝网电影所有影视资源完全免费，无需注册或登录即可在线观看，我们致力于为影迷提供最便捷的观影体验。",
  },
  {
    question: "被窝电影网的视频资源画质如何？",
    answer: "被窝网电影提供高清画质（1080P及以上），大部分热门影片支持4K超清画质，配合先进的视频压缩技术，确保流畅不缓冲的观影体验。",
  },
  {
    question: "被窝网电影的资源更新频率是多少？",
    answer: "我们每日同步更新最新电影和电视剧资源，院线下映的热门影片通常在1-2周内上线，热播剧集同步更新，确保您能第一时间观看最新内容。",
  },
  {
    question: "观看过程中遇到卡顿怎么办？",
    answer: "被窝网电影采用多线路智能切换技术，当某条线路出现卡顿时系统会自动切换至最优线路。您也可以手动切换播放源，或检查您的网络连接状况。",
  },
  {
    question: "被窝网电影支持哪些设备观看？",
    answer: "被窝网电影完美适配电脑、平板和手机端，支持主流浏览器（Chrome、Safari、Edge等），无论在家还是出行都能轻松追剧看电影。",
  },
  {
    question: "如何在被窝网电影上找到想看的影片？",
    answer: "您可以通过首页的分类导航按类型浏览，或使用搜索功能直接查找影片名称。我们还提供智能推荐功能，根据您的观影偏好推荐相关内容。",
  },
];